'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PatentanzahlSchema = {
  title: 'Patentanzahl',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/patentanzahl.js
// module id = ZYGQ
// module chunks = 0